<template>
  <h1>Here are the term and Conditions</h1>
</template>